import React from 'react';
import theme from 'config/theme';
import Styled from './Tooltip.styled';

export default function Tooltip(): JSX.Element {
    return (
        <Styled.StandardTooltip
            border
            effect="solid"
            backgroundColor={theme.colors.gray.light}
            textColor={theme.colors.font.onPrimaryDarker}
            borderColor={theme.colors.gray.dark}
        />
    );
}
